import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonBookingCard = ({ counts }) => {
  return (
    <>
      {Array(counts)
        .fill(0)
        .map((item, i) => (
          <div
            key={i}
            className="bg-white rounded-card-lg max-md:rounded-card border border-black/[0.06] shadow-card-sm p-5 max-md:p-4 mb-4 max-md:mb-3"
          >
            <div className="flex items-start lg:items-center w-full flex-col lg:flex-row relative">
              <div className="space-y-1 pr-36 lg:min-w-[180px]">
                <Skeleton count={3} height={"1.5rem"} width={"7rem"} />
              </div>
              <div className="space-y-3 mt-3 lg:mt-0 pr-36 flex-1 max-w-full w-full">
                <div className="flex items-center flex-wrap w-full">
                  <Skeleton height={"1.5rem"} width={"100%"} />
                </div>
                <div className="flex items-center flex-wrap">
                  <Skeleton height={"1.5rem"} width={"100%"} />
                </div>
              </div>
              <div className="absolute lg:relative -top-[8px] right-0">
                <Skeleton width={"6rem"} height={"4.5rem"} borderRadius={12} />
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default SkeletonBookingCard;
